import { Controller } from "@hotwired/stimulus"
import "./data_issue_report_component.css"

export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.focusInput = () => this.inputTarget.focus()
    window.jQuery(this.element).on("shown.bs.modal", this.focusInput)
  }

  disconnect() {
    window.jQuery(this.element).off("shown.bs.modal", this.focusInput)
  }
}
